import React, { FC } from 'react';
import styled from 'styled-components';
import { Black, White } from '../../styles/colours';

const OffscreenCheckbox = styled.input`
  position: absolute;
  left: -9999px;
`;

export const StyledMenuPopUp = styled.div`
  position: absolute;
  transition: all 0.5s ease;
  top: 60px;
  right: 0;
  background: ${White};
  color: ${Black};
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  padding: 1rem;
  border-radius: 4px;
  min-width: 300px;
  z-index: 2;

  &:before {
    content: ' ';
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid ${White};
    position: absolute;
    right: 25%;
    top: -10px;
  }
`;

interface IMenuProps {
  displayed: boolean;
  setDisplayed: (display: boolean) => void;
  className?: string;
}

export const MenuToggleButton: FC<IMenuProps> = ({
  displayed,
  setDisplayed,
  children,
}) => {
  return (
    <label>
      <OffscreenCheckbox
        type="checkbox"
        data-type="menu-toggle-button"
        onChange={() => setDisplayed(!displayed)}
        checked={displayed}
      />
      {children}
    </label>
  );
};
export const MenuPopUp: FC<IMenuProps> = ({
  displayed,
  children,
  className,
}) => {
  if (displayed) {
    return (
      <StyledMenuPopUp data-type="menu-popup" className={className}>
        {children}
      </StyledMenuPopUp>
    );
  }
  return null;
};
